import React, { useState } from "react";
import { ApiService } from "../services";
import { useSnackbar } from "react-simple-snackbar";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import TooltipComponent from "../gComponents/gTooltip";
import { Info } from "@material-ui/icons";
import GButton from "../gComponents/gButton";

export default function VariantTypeForm(props) {
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [openSnackbar] = useSnackbar();
  const [switchVal, setSwitchVal] = useState(
    props.variantData.minimum === 1 ? true : false
  );
  const priceOptions = [
    {
      key: "None",
      value: "0",
      tooltipValue:
        "Choosing this will not effect product pricing. Ex: Color Selection",
    },
    {
      key: "Additional",
      value: "1",
      tooltipValue:
        "Price of variant will be added to the actual product price. Ex: Extra Toppings, Extra Hanger",
    },
    {
      key: "Choice",
      value: "2",
      tooltipValue:
        "Price of variant will become the actual product price. Ex: Size or Weight Options",
    },
  ];
  const initialValues = {
    title: props.variantData.title || "",
    price_type: props.variantData.price_type || "",
    minimum: props.variantData.minimum || 0,
    maximum: props.variantData.maximum || "",
    status: props.variantData.status || 0,
  };

  const onSubmit = (values) => {
    setIsBtnDisabled(true);
    values.minimum = switchVal === true ? 1 : 0;
    if (values.price_type != "1") {
      values.maximum = 1;
      values.minimum = 0;
    }
    console.log(values);

    let method = !props.isEmpty ? "PUT" : "POST";
    let url = !props.isEmpty
      ? "product/variant/types/" + props.variantData.id
      : "product/variant/types";

    ApiService({ method: method, route: url, body: values }).then(
      (response) => {
        console.log("r" + response.data.status_code);
        if (response.data.status_code === 1) {
          props.setVtvisible(false);
          props.onSubmit(response.data.data);
        }
        setIsBtnDisabled(false);
        openSnackbar(response.data.message);
        return;
      }
    );
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Required"),
    price_type: Yup.string().required("Required"),
    maximum: Yup.string().when("price_type", {
      is: "1",
      then: Yup.string().required("Required"),
    }),
  });

  if (props.vtvisible === false) {
    return null;
  }

  return (
    <>
      <div className="modal-header">
        {!props.isEmpty ? "Edit" : "Add"} Variant Type
      </div>
      <div className="modal-body">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ values }) => (
            <Form>
              <FormikControl
                control="input"
                type="text"
                label="Title"
                name="title"
              />

              <FormikControl
                control="radio"
                label="Price options"
                name="price_type"
                options={priceOptions}
                key_title="key"
                key_value="value"
                divstyle={{ display: "block", padding: "5px 0" }}
              />

              {values.price_type === "1" ? (
                <React.Fragment>
                  <h4 style={{ margin: "15px 15px 5px" }}>
                    Apply Rules on Variants
                  </h4>

                  <div style={{ margin: "15px 15px 5px" }}>
                    <label style={{ display: "inline-block" }}>
                      Selection Mandatory*
                      <TooltipComponent
                        title=" 
                      When Selection Mandatory is turned on, customer must need to Choose at least one option out of the available variant options"
                        position="bottom"
                        id="twilio_number"
                      >
                        <Info fontSize="small" />
                      </TooltipComponent>
                    </label>
                    <FormikControl
                      control="toggle"
                      isToggled={switchVal}
                      name="minimum"
                      onToggle={() => {
                        setSwitchVal(!switchVal);
                      }}
                    />
                  </div>

                  <FormikControl
                    control="input"
                    type="text"
                    label="Maximum Selection"
                    name="maximum"
                    style={{
                      display: "inline-block",
                      width: "70px",
                      marginLeft: "15px",
                      padding: "0.45rem",
                    }}
                    labelStyle={{
                      display: "inline-block",
                      padding: "0px 15px 0 0",
                    }}
                  />
                </React.Fragment>
              ) : (
                ""
              )}

              <br />
              <GButton
                disabled={isBtnDisabled}
                type="submit"
                variant="condensed"
                children={props.isEmpty ? "Create" : "Update"}
                style={{ width: "calc(100% - 30px)", margin: "0 15px" }}
              />
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
}
